<template>
  <div class="mobile-dynamic tw-w-full tw-bg-white tw-py-8 tw-px-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-mb-2">
      <h2 class="section-title">
        {{ $t("最新活动") }}
      </h2>
      <div
        class="tw-flex tw-items-center tw-cursor-pointer hover:tw-text-primary tw-transition-colors"
        @click="handleMoreClick"
      >
        <span class="more-text">
          {{ $t("更多活动") }}
        </span>
        <img
          src="@/assets/home/icon_fanhui.png"
          alt=""
          class="tw-w-4 tw-h-4 tw-ml-1"
        />
      </div>
    </div>

    <div class="tw-flex tw-w-full">
      <div class="first-card tw-relative" style="width: 100%; flex-shrink: 0;">
        <img
          src="@/assets/home/first.png"
          alt=""
          class="tw-absolute"
          style="
            width: 111.64px;
            height: 104.46px;
            top: 16px;
            right: 38px;
            bottom: 12px;
            z-index: 1;
          "
        />

        <div
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-px-4 tw-relative"
          style="
            height: 132px;
            background: linear-gradient(79deg, #fffefe 0%, #fcf1e8 100%);
            border: 1px solid #e9e9e9;
            border-radius: 12px;
          "
        >
          <img
            src="@/assets/home/run.png"
            alt=""
            class="tw-mb-3"
            style="height: 32px"
          />
          <p
            class="tw-text-sm tw-font-medium tw-text-textMain tw-mb-2 tw-leading-tight"
          >
            {{ $t("凭借12年Web3行业经验居行业领先地位") }}
          </p>
          <p class="tw-text-xs tw-text-textDisabled tw-leading-tight">
            {{ $t("为企业提供稳定、高效的落地支持") }}
          </p>
        </div>
      </div>
    </div>

    <div v-if="activityList.length" class="activity-list">
      <div
        v-for="item in activityList"
        :key="item.id"
        class="activity-card"
        @click="handleActivityClick(item)"
      >
        <img :src="item.image || skeIcon" alt="" class="activity-cover" />
        <div class="activity-info">
          <div class="activity-title-row">
            <h3 class="activity-title">{{ item.name }}</h3>
            <span
              class="activity-status"
              :class="{ ended: item.status === 3 }"
            >
              {{ $t(getStatusText(item.status)) }}
            </span>
          </div>
          <p class="activity-meta">{{ getTimeText(item) }}</p>
          <p class="activity-meta">{{ getLocationText(item.location) }}</p>
          <p v-if="false" class="activity-count">
            {{ item.registrationCount || 0 }}
            {{ item.status === 3 ? $t("人参会") : $t("人报名") }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import skeIcon from "@/assets/activityMeet/ske.png";
import { getActivityList } from "@/api/activityMeet/index.js";
import {
  formatActivityTime,
  getActivityStatusText,
  isOnlineLocation,
  normalizeHomeActivities,
} from "./utils/homeActivity";

export default {
  name: "mobileNewDynamic",
  data() {
    return {
      activityList: [],
      skeIcon,
    };
  },
  created() {
    this.fetchActivityList();
  },
  methods: {
    async fetchActivityList() {
      try {
        const { code, data } = await getActivityList();
        if (code !== 0) return;
        this.activityList = normalizeHomeActivities(data);
      } catch (error) {
        console.warn("获取首页活动失败", error);
      }
    },
    getStatusText(status) {
      return getActivityStatusText(status);
    },
    getTimeText(activity) {
      const time = formatActivityTime(activity, this.$i18n.locale);
      return time ? `${time.date} ${time.time} UTC+8` : "--";
    },
    getLocationText(location) {
      if (isOnlineLocation(location)) {
        return this.$t("在线会议");
      }
      return location || "--";
    },
    handleActivityClick(item) {
      if (!item || !item.id) return;
      this.$router.push({
        name: "activity-detail",
        params: { id: item.id },
      });
    },
    handleMoreClick() {
      this.$router.push({
        path: "/activity",
      });
    },
  },
};
</script>

<style scoped>
.section-title {
  color: #111111;
  font-size: 16px;
  font-weight: 600;
}

.more-text {
  color: #666666;
  font-size: 14px;
  font-weight: 400;
}

.activity-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.activity-card {
  display: flex;
  gap: 12px;
  min-height: 116px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
}

.activity-cover {
  flex: 0 0 88px;
  width: 88px;
  height: 88px;
  object-fit: cover;
  border-radius: 8px;
}

.activity-info {
  min-width: 0;
  flex: 1;
}

.activity-title-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.activity-title {
  flex: 1;
  min-width: 0;
  margin-bottom: 6px;
  overflow: hidden;
  color: #111111;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity-status {
  flex: 0 0 auto;
  padding: 2px 6px;
  color: #ffffff;
  font-size: 12px;
  line-height: 18px;
  background: #01bd8b;
  border-radius: 4px;
}

.activity-status.ended {
  color: #666666;
  background: #e9e9e9;
}

.activity-meta,
.activity-count {
  margin-bottom: 4px;
  overflow: hidden;
  color: #666666;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity-count {
  display: none;
  color: #4077f8;
}
</style>
